import React, { useState } from "react";
import { TextInput, ActionIcon, Group } from "@mantine/core";
import { IconPlus, IconCheck, IconX } from "@tabler/icons-react";

const InlineTaskCreate = ({ columnId, onTaskCreated }) => {
    const [isCreating, setIsCreating] = useState(false);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!title.trim()) return;

        setLoading(true);
        try {
            await onTaskCreated(title, columnId);
            setTitle("");
            setIsCreating(false);
        } catch (error) {
            console.error("Error creating task:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleCreate();
        } else if (e.key === "Escape") {
            setTitle("");
            setIsCreating(false);
        }
    };

    if (!isCreating) {
        return (
            <ActionIcon
                variant="subtle"
                size="sm"
                onClick={() => setIsCreating(true)}
                style={{ width: "100%" }}
            >
                <Group gap="xs" style={{ width: "100%" }}>
                    <IconPlus size={16} />
                    <span style={{ fontSize: "0.875rem", color: "var(--mantine-color-dimmed)" }}>
                        Quick add task...
                    </span>
                </Group>
            </ActionIcon>
        );
    }

    return (
        <Group gap="xs" wrap="nowrap">
            <TextInput
                placeholder="Task title (press Enter)"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
                disabled={loading}
                style={{ flex: 1 }}
                size="sm"
            />
            <ActionIcon
                color="green"
                onClick={handleCreate}
                disabled={!title.trim() || loading}
                loading={loading}
                size="sm"
            >
                <IconCheck size={16} />
            </ActionIcon>
            <ActionIcon
                color="red"
                onClick={() => {
                    setTitle("");
                    setIsCreating(false);
                }}
                disabled={loading}
                size="sm"
            >
                <IconX size={16} />
            </ActionIcon>
        </Group>
    );
};

export default InlineTaskCreate;
